import type { Components } from '@mui/material/styles';

export default function MUICollapse(): Components['MuiCollapse'] {
  return {};
}
